import { render, staticRenderFns } from "./HeaderOpeningTimes.vue?vue&type=template&id=29bf9f30&"
import script from "./HeaderOpeningTimes.vue?vue&type=script&lang=ts&"
export * from "./HeaderOpeningTimes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports